// src/components/helpers/ScholarshipBookDialog.js
import React, { useState } from "react"; // eslint-disable-line
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import { pdf, Document, Page, Text, View } from "@react-pdf/renderer"; // add these imports

import { useLazyGetScholarshipDataByCityQuery } from "../../services/scholarship-book";
import ScholarshipBookPDF from "./ScholarshipBookPDF";

const getPDF = async () => {
  const { pdf } = await import("@react-pdf/renderer");
  return pdf;
};

const ScholarshipBookDialog = ({ open, onClose, addNotification }) => {
  const [trigger, { isLoading }] = useLazyGetScholarshipDataByCityQuery();
  // const [previewData, setPreviewData] = useState(null);
  // const [showPreview, setShowPreview] = useState(false);

  const handleDownload = async (cityId) => {
  try {
    const result = await trigger(cityId).unwrap();
    if (!result.success) {
      throw new Error(result.message || "Failed to fetch data");
    }

    const cityMap = {
      1: "Nanaimo",
      2: "Ladysmith",
    };
    const cityName = cityMap[cityId.toString()] || "Unknown";

    const blob = await (
      await getPDF()
    )(<ScholarshipBookPDF data={result.data} city={cityName} />).toBlob();
    
    console.log("Blob created:", blob);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const filename = `${cityName}-ScholarshipBook-${new Date().toLocaleDateString()}.pdf`;
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    onClose();
  } catch (error) {
    console.error("Error generating PDF:", error);
    addNotification("Error generating PDF. Please try again.", "error");
  }
};

  

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle textAlign="center">Download Awards PDFs</DialogTitle>
        <DialogContent>
          <Typography>Choose the PDF you want to download:</Typography>
        </DialogContent>
        <DialogActions>
         
          <Button
            variant="contained"
            onClick={async () => {
              await handleDownload(2);
            }}
            disabled={isLoading}
            sx={{
              margin: "0 1rem 0.5rem 0",
              color: "#FFF",
              backgroundColor: "#d9534f",
            }}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
          >
            {isLoading ? "Downloading Ladysmith PDF" : "Ladysmith Awards PDF"}
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              await handleDownload(1);
            }}
            disabled={isLoading}
            sx={{
              margin: "0 1rem 0.5rem 0",
              color: "#FFF",
              backgroundColor: "#d9534f",
            }}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
          >
            {isLoading ? "Downloading Nanaimo PDF" : "Nanaimo Awards PDF"}
          </Button>
          <Button variant="contained" onClick={onClose} color="secondary">
            Close
          </Button>
        </DialogActions>
        <Typography
          variant="caption"
          style={{ padding: "0 1rem", marginBottom: 5, textAlign: "center" }}
        >
          A blank page will appear while the download is being prepared and
          transferred. <br />
          Please wait until the process completes.
        </Typography>
      </Dialog>
      {/* {showPreview && previewData && (
        <Dialog
          open={showPreview}
          onClose={() => setShowPreview(false)}
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle textAlign="center">
            PDF Preview - {previewData?.city}
          </DialogTitle>
          <DialogContent style={{ height: "80vh" }}>
            <PDFViewer width="100%" height="100%">
              <ScholarshipBookPDF
                data={previewData?.data}
                city={previewData?.city}
              />
            </PDFViewer>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setShowPreview(false)}
              color="secondary"
            >
              Close Preview
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
    </>
  );
};

export default ScholarshipBookDialog;
